import { graphql, useStaticQuery } from 'gatsby'

const useInfoSectionData = () => {
  const data = useStaticQuery(
    graphql`
      query INFOSECTION_DATA_QUERY {
        markdownRemark(frontmatter: { templateKey: { eq: "info-section" } }) {
          frontmatter {
            title,
            buttonText,
            title2,
            itens {
              title,
              icon,
              description,
            }
          }
          html
        }
      }
    `
  )
  return data.markdownRemark
}

export default useInfoSectionData
